function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M63.0704 47.7847C62.3974 47.1118 61.8799 45.7924 61.5129 44.549C63.5449 43.4975 65.1735 41.5167 66.0547 39.0416C67.2253 38.5373 68.0686 37.2212 68.0686 35.662C68.0686 34.3443 67.4634 33.2018 66.5706 32.5719C65.7274 27.8316 62.2883 24.2784 58.1664 24.2784C54.0445 24.2784 50.6071 27.8299 49.7622 32.5719C48.8694 33.2018 48.2642 34.3443 48.2642 35.662C48.2642 37.2212 49.1058 38.5373 50.2781 39.0416C51.1593 41.5167 52.7896 43.4975 54.8199 44.549C54.4529 45.7924 53.9337 47.1118 53.2624 47.7847C53.2624 47.7847 42.7138 50.9295 42.7138 54.2627C42.7138 57.5927 42.7138 60 42.7138 60H54.557L56.8205 52.2439C56.2716 52.2241 55.8285 51.7793 55.8285 51.2254V50.0714C55.8285 49.5059 56.2881 49.0463 56.8536 49.0463H59.4808C60.048 49.0463 60.5059 49.5059 60.5059 50.0714V51.2238C60.5059 51.7777 60.0645 52.2224 59.5139 52.2423L61.7774 59.9983H73.6207C73.6207 59.9983 73.6207 57.591 73.6207 54.2611C73.6207 50.9295 63.0704 47.7847 63.0704 47.7847Z",
  fill: "black"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M58.1664 19.9052C58.1928 19.9052 58.2176 19.9035 58.2441 19.9035C58.9567 19.8804 59.6247 19.553 60.0777 19.0041L73.1759 3.15964L69.3516 0L58.049 13.6752L49.8978 4.98168L46.2801 8.37444L56.3576 19.1215C56.8271 19.6225 57.4819 19.9052 58.1664 19.9052Z",
  fill: "black"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M20.3566 47.7847C19.6837 47.1118 19.1661 45.7924 18.7991 44.549C20.8311 43.4975 22.4597 41.5167 23.341 39.0416C24.5116 38.5373 25.3548 37.2212 25.3548 35.662C25.3548 34.3443 24.7496 33.2018 23.8568 32.5719C23.0136 27.8316 19.5745 24.2784 15.4526 24.2784C11.3307 24.2784 7.8933 27.8299 7.04842 32.5719C6.15558 33.2018 5.55044 34.3443 5.55044 35.662C5.55044 37.2212 6.39202 38.5373 7.56428 39.0416C8.44553 41.5167 10.0758 43.4975 12.1061 44.549C11.7391 45.7924 11.2199 47.1118 10.5486 47.7847C10.5486 47.7847 0 50.9295 0 54.2627C0 57.5927 0 60 0 60H11.8433L14.1068 52.2439C13.5578 52.2241 13.1147 51.7793 13.1147 51.2254V50.0714C13.1147 49.5059 13.5744 49.0463 14.1398 49.0463H16.7671C17.3342 49.0463 17.7922 49.5059 17.7922 50.0714V51.2238C17.7922 51.7777 17.3507 52.2224 16.8001 52.2423L19.0636 59.9983H30.9069C30.9069 59.9983 30.9069 57.591 30.9069 54.2611C30.9069 50.9295 20.3566 47.7847 20.3566 47.7847Z",
  fill: "black"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M8.85557 21.3172L15.4526 14.7218L22.0497 21.3172L25.5565 17.8104L18.9595 11.215L25.5565 4.61793L22.0497 1.11108L15.4526 7.70812L8.85557 1.11108L5.34872 4.61793L11.9458 11.215L5.34872 17.8104L8.85557 21.3172Z",
  fill: "black"
});

var SvgTrackingProgress = function SvgTrackingProgress(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 74,
    height: 60,
    viewBox: "0 0 74 60",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTrackingProgress, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trackingProgress.babaa397.svg";
export { ForwardRef as ReactComponent };